import { Point } from '../../utils/editorReactIcons';
export { Point };
export default Point;
